/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedIconBubbleEmail_viewer = {|
  +isPdpStfEnabled: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedIconBubbleEmail_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isPdpStfEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "enablePdpStf",
          "type": "String!"
        }
      ],
      "name": "isEnabled",
      "storageKey": "isEnabled{\"key\":\"enablePdpStf\"}"
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
